"use strict";

var _regeneratorRuntime = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _taggedTemplateLiteral = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _classCallCheck = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["mutation {\n      sendTransferTransaction(\n        inputRaw: {\n          chainId: \"", "\",\n          feeCycle: \"", "\",\n          feeAssetId: \"", "\",\n          nonce: \"", "\",\n          timeout: \"", "\"\n        },\n        inputAction: {\n          carryingAmount: \"", "\",\n          carryingAssetId: \"", "\",\n          receiver: \"", "\",\n        },\n        inputEncryption: {\n          txHash: \"", "\",\n          pubkey: \"", "\",\n          signature: \"", "\"\n        }\n      )}"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["{ getBalance(address: \"", "\", id: \"", "\") }"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        {\n          getLatestEpoch {\n            header {\n              epochId\n            }\n          }\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apollo_boost_1 = __importDefault(require("apollo-boost")); // tslint:disable-next-line:no-submodule-imports


require("cross-fetch/polyfill");

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var random_bytes_1 = __importDefault(require("random-bytes"));

var constant_1 = require("../core/constant");

var utils_1 = require("../utils");
/**
 * Client for call Muta GraphQL API
 */


var Client =
/*#__PURE__*/
function () {
  function Client(entry, chainId) {
    _classCallCheck(this, Client);

    this.endpoint = entry;
    this.chainId = chainId;
    this.client = new apollo_boost_1.default({
      fetchOptions: {
        fetchOptions: {
          mode: 'no-cors'
        }
      },
      uri: this.endpoint
    });
  }
  /**
   * get epoch id(or epoch height as a hex string)
   */


  _createClass(Client, [{
    key: "getLatestEpochId",
    value: function getLatestEpochId() {
      return this.query(graphql_tag_1.default(_templateObject())).then(function (res) {
        return res.data.getLatestEpoch.header.epochId;
      });
    }
  }, {
    key: "getEpochHeight",
    value: function () {
      var _getEpochHeight = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var epochId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getLatestEpochId();

              case 2:
                epochId = _context.sent;
                return _context.abrupt("return", Number('0x' + epochId));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEpochHeight() {
        return _getEpochHeight.apply(this, arguments);
      }

      return getEpochHeight;
    }()
    /**
     *
     * @param address
     * @param assetId Identifier of asset in Muta. ie.
     */

  }, {
    key: "getBalance",
    value: function getBalance(address, assetId) {
      return this.query(graphql_tag_1.default(_templateObject2(), address, assetId)).then(function (res) {
        return Number('0x' + res.data.getBalance);
      });
    }
    /**
     * A transaction often takes a lot of message like nonce, block height,
     * timeout and so on. This function helps you to assemble a transaction quickly
     * with some commonly used parameters.
     * @param options
     */

  }, {
    key: "prepareTransferTransaction",
    value: function () {
      var _prepareTransferTransaction = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(options) {
        var _a, _b, nonce, height, timeout;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                nonce = utils_1.toHex(random_bytes_1.default.sync(32).toString('hex'));
                _context2.next = 3;
                return this.getEpochHeight();

              case 3:
                height = _context2.sent;
                timeout = utils_1.toHex(height + constant_1.DEFAULT_TIMEOUT_GAP - 1);
                return _context2.abrupt("return", {
                  chainId: this.chainId,
                  nonce: nonce,
                  timeout: timeout,
                  carryingAmount: options.carryingAmount,
                  carryingAssetId: options.carryingAssetId,
                  receiver: options.receiver,
                  feeAssetId: (_a = options.feeAssetId, _a !== null && _a !== void 0 ? _a : options.carryingAssetId),
                  feeCycle: (_b = options.feeCycle, _b !== null && _b !== void 0 ? _b : '0xff')
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function prepareTransferTransaction(_x) {
        return _prepareTransferTransaction.apply(this, arguments);
      }

      return prepareTransferTransaction;
    }()
    /**
     * Return a transaction hash after sentTransferTransaction
     */

  }, {
    key: "sendTransferTransaction",
    value: function () {
      var _sendTransferTransaction = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(options) {
        var _a, _b, res;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.mutation(graphql_tag_1.default(_templateObject3(), options.chainId, options.feeCycle, options.feeAssetId, options.nonce, options.timeout, options.carryingAmount, options.carryingAssetId, options.receiver, options.txHash, options.pubkey, options.signature));

              case 2:
                res = _context3.sent;
                return _context3.abrupt("return", (_b = (_a = res) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.sendTransferTransaction);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function sendTransferTransaction(_x2) {
        return _sendTransferTransaction.apply(this, arguments);
      }

      return sendTransferTransaction;
    }()
  }, {
    key: "query",
    value: function query(_query) {
      return this.client.query({
        query: _query
      });
    }
  }, {
    key: "mutation",
    value: function mutation(_mutation) {
      return this.client.mutate({
        mutation: _mutation
      });
    }
  }]);

  return Client;
}();

exports.Client = Client;